import React from "react";

const FormSubSection = props => {
  const {children, title, show, action, actionContent} = props;
  return (
    show && (
      <div className="row">
        <div className="col-12">
          <div className="d-flex align-items-center">
            <h6 className="text-blue-cermaq my-3">{title}</h6>
            {action && (
              <button
                type="button"
                className="btn bg-primary text-white ms-auto d-flex align-items-center"
                onClick={() => action()}
              >
                {actionContent}
              </button>
            )}
          </div>
        </div>
        <div className="col-12">{children}</div>
      </div>
    )
  );
};

export default FormSubSection;
